import { getConfig } from 'config/configuration'
import { createRoot } from 'react-dom/client'

import { startApi } from './api/init-api'
import { store } from './redux/store'
import initialiseSentry from './sentry/sentry'
import App from './app'
import { unregister as unregisterServiceWorker } from './serviceWorker'

export const start = () => {
  const container = document.getElementById('root')
  const root = createRoot(container as HTMLElement)

  startApi(getConfig())

  initialiseSentry()

  root.render(<App store={store} />)
}

unregisterServiceWorker()
